import { render, staticRenderFns } from "./WeeklyTestMarkSheetRecord.vue?vue&type=template&id=09c270d7&scoped=true&"
import script from "./WeeklyTestMarkSheetRecord.vue?vue&type=script&lang=js&"
export * from "./WeeklyTestMarkSheetRecord.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyTestMarkSheetRecord.vue?vue&type=style&index=0&id=09c270d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c270d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VProgressCircular,VTextField,VTooltip})
